import { useParams } from '@tanstack/react-router'
import { SalesIntakeWorkView } from '../components/SalesIntakeWorkView'

/**
 * Full-page per-intake working view (email-thread-viewer sprint). Thin
 * wrapper reading `intakeId` from the route param.
 */
export function SalesIntakePage() {
  const params = useParams({ strict: false }) as { intakeId?: string }
  const intakeId = params.intakeId
  if (!intakeId) {
    return <div className="p-8 text-tertiary">Invalid intake id.</div>
  }
  return <SalesIntakeWorkView intakeId={intakeId} />
}
